export default __webpack_public_path__ + "static/media/logo-v2.73014fc7.svg";